import { gql } from '@apollo/client';

export const fetchCloudSitesInPPC = gql`
  query fetchCloudSitesInPPC($searchParams: CloudSiteSearchParams) {
    partnerCloudSites(searchParams: $searchParams) {
      totalCount
      nodes {
        cloudSiteId
        cloudSiteHostname
        shipToParty {
          id
          name
          addressLine1
          addressLine2
          state
          postcode
          country
          city
        }
      }
    }
  }
`;
